<template>
<div class='swiper-wrapper' v-show='element.element_config.slides.length != 0'>
    <template v-for='slide in element.element_config.slides' :key='slide.id'>
        <div class="swiper-slide" :style="{'width': slide_styles.width}" @click='slideClick(slide)'>
            <div :class="{'builder-mode-selected-slide' : page_builder_mode && slide.id == selected_carousel_slide}">
                <DynamicImageContainer :style="{'height': slide_styles.height, 'width': slide_styles.width}" class='slide-img' :image='slide.img_src' v-show='slide.img_src != ""'/>
                <div class='no-selected-image' :style="{'height': slide_styles.height, 'width': slide_styles.width}"  v-show='slide.img_src == ""'>
                    <div v-if='page_builder_mode' class='no-image-selected-text'>No image selected</div>
                </div>
                <div class='slide-text' v-html='slide.text'></div>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    props: ['element', 'page_builder_mode', 'selected_carousel_slide', 'carousel_type'],
    emits: ['selectedCarouselTypeListener'],
    data(){
        return{
             slide_styles: {
                width: '0px'
            }
        }
    },
    methods:{
        slideClick(slide){
            if(!this.page_builder_mode){
                if(slide.url != ''){
                    this.$router.push(slide.url);
                }
            }
        },
        setStyles(){
            if(this.element.element_config.compiled_styles != null){
                this.slide_styles = this.element.element_config.compiled_styles.slide;
            }
        }
    },
    mounted(){
        this.$emit('selectedCarouselTypeListener', this.element.element_config.slides);
        this.setStyles();
    },
    watch:{
       'element': {
            handler(){
                this.setStyles();
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.slide-img{
    width: 200px;
    height: auto;
}

.no-selected-image{
    text-align: center;
}

.no-image-selected-text{
    padding-top: 30px;
    font-size: 1rem;
    color: #495057;
}

.slide-text{
    text-align: center;
    font-size: 1rem;
    text-transform: uppercase;
    // text-decoration: underline;
    font-weight: 500;
}
.builder-mode-selected-slide{
    border: 1px #c92a2a dashed;
    z-index: 1;
    border-radius: 2px;
}
</style>